"use client"

import styles from "./FixedSocialIcons.module.css"
import wpIcon from "../../assets/images/wp-icon.png"
import instaIcon from "../../assets/images/insta-logo.png"

/*
  Sayfanın yan tarafında bulunan ve WhatsApp, Instagram icomlarınıgörüntüleyen sabit simge bileşeni.
*/
export default function FixedSocialIcons() {
  return (
    // Sosyal medya simgeleri konteyner
    <div className={styles.fixedSocialIcons}>
      {/* WhatsApp bağlantısı */}
      <a 
        href="https://wa.me/905337674950" 
        target="_blank" 
        rel="noreferrer" 
        className={styles.socialLink}
        aria-label="WhatsApp"
      >
        <img src={wpIcon} alt="WhatsApp" className={styles.socialIcon} />
      </a>
      
      {/* Instagram bağlantısı */}
      <a 
        href="https://instagram.com/estaverde_clinic" 
        target="_blank" 
        rel="noreferrer" 
        className={styles.socialLink}
        aria-label="Instagram"
      >
        <img src={instaIcon} alt="Instagram" className={styles.socialIcon} />
      </a>
    </div>
  )
}
